/**
 * SilkTale 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const silktalePaymentConfig: BrandPaymentConfig = {
  brand: 'silktale',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/silktale/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/silktale/vip_bg.webp',
      memberSubscribeBg: '/images/silktale/member_subscribe_bg.webp',
      vipIcon: '/images/silktale/vip_icon2.png',
      vipDiscountIcon: '/images/silktale/vip_discount.png',
      discountBg: '/images/silktale/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: '#FD9540',
      purpleTextGradient: 'linear-gradient(180deg, #FFCAA8 0%, #FFE0CC 70%, #FFF8F5 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #FD9540, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FD9540',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FFF8F5',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #FFCAA8 0%, #FFE0CC 70%, #FFF8F5 100%)',
      pinkGradient: '#FD9540',
      memberSubscribeBg: '/images/silktale/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
